import Card from "@mui/material/Card";
import "./index.css"
// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import {useState,useEffect} from 'react'
// Soft UI Dashboard Materail-UI example components
// import {Table as Table1} from '@mui/material/Table';
import Table from "examples/Tables/Table";
import {usePapaParse} from "react-papaparse"
import { PDFDocument, StandardFonts } from 'pdf-lib';
import axios from "axios";
import Icon from "@mui/material/Icon";
// Data
import { Auth } from "aws-amplify";
import localPngImage from 'assets/images/PowerBySijil.png';
 
 
function Projects(eventName) {
  const [rows,setrows] = useState([])
const [modal,setmodal] = useState(false)
  const [username, setusername] =useState("")
  const [name, setname] =useState()
  const { readRemoteFile } = usePapaParse();
  const [data1,setdata1] = useState([])
const [rowes, setrowes] = useState([])
const [datamodal,setdatamodal]= useState()
const [title,settitle] = useState(eventName)
const [load,setload] = useState(false)
 
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };
 
  useEffect(()=>{
    async function getuser(){
      Auth.currentUserInfo().then(value=>{
        console.log(value.attributes["custom:company"])
        console.log(value.attributes["custom:fullname"])
        setname(value.attributes["custom:fullname"])
        setusername(value.username)
      })
    }
    getuser()
  },[])
 
  useEffect(()=>{
    row()
  },[])
 
  useEffect(()=>{
    row()
 
  },[username])
 
  const row = async () => {
    let test = [];
  
    try {
      const eventsResponse = await axios.get("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getEvents");
      let rows1 = [];
      setrows([]);
  
      for (const certs of eventsResponse.data) {
        try {
          const certFilesResponse = await axios.get(`https://0hpj8m43y7.execute-api.ap-southeast-1.amazonaws.com/default/getCertificateFiles?id=${certs.id}.csv`);
  
          if (certFilesResponse.data === "success") {
            console.log(certs.id);
  
            // Cache-busting by appending a timestamp to the URL
            const cacheBustingUrl = `https://certificatesys.s3.ap-southeast-1.amazonaws.com/${certs.id}.csv?timestamp=${new Date().getTime()}`;
  
            readRemoteFile(cacheBustingUrl, {
              complete: async (results) => {
                let certDataByEvent = {};
                for (const val of results.data) {
                  if ((val['cognito:username'] || val['ic_number']) === username) {
                    if (!certDataByEvent[certs.id]) {
                      certDataByEvent[certs.id] = [];
                    }
                    certDataByEvent[certs.id].push(val);
                  }
                }
  
                for (const eventId in certDataByEvent) {
                  setrows(oldArray => [...oldArray, {
                    download: <SuiButton variant="text" textGradient color="warning" size="large" onClick={async () => {
                      console.log(certs.tenant);
  
                      try {
                        const certResponse = await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getCert2", { event: certs.id, tenant: certs.tenant });
                        console.log(certResponse);
                        let ach = [];
                        const certData = certResponse.data;
  
                        certDataByEvent[eventId].forEach(val => {
                          const achievements = val["custom:achievements"] || val["category"];
                          const tenant = certs.tenant;
  
                          if (tenant === "admin") {
                            switch (achievements) {
                              case "winner 1":
                                ach.push("winner 1", "participant", "training", "finalist");
                                break;
                              case "winner 2":
                                ach.push("winner 2", "participant", "training", "finalist");
                                break;
                              case "winner 3":
                                ach.push("winner 3", "participant", "training", "finalist");
                                break;
                              case "training":
                                ach.push("participant", "training");
                                break;
                              case "finalist":
                                ach.push("participant", "training", "finalist");
                                break;
                              case "participant":
                                ach.push("participant");
                                break;
                              case "advisor":
                                ach.push("advisor");
                                break;
                              case "bestproto":
                                ach.push("bestproto", "participant", "training", "finalist");
                                break;
                              case "bestpcb":
                                ach.push("bestpcb", "participant", "training", "finalist");
                                break;
                              case "bestsocmed":
                                ach.push("bestsocmed", "participant", "training", "finalist");
                                break;
                              case "iotsustain":
                                ach.push("iotsustain", "participant", "training", "finalist");
                                break;
                              case "bestdemo":
                                ach.push("bestdemo", "participant", "training", "finalist");
                                break;
                              case "women":
                                ach.push("women", "participant", "training", "finalist");
                                break;
                              case "bestproposal":
                                ach.push("bestproposal", "participant", "training", "finalist");
                                break;
                              case "bestvideo":
                                ach.push("bestvideo", "participant", "training", "finalist");
                                break;
                              case "coding":
                                ach.push("coding", "participant", "training", "finalist");
                                break;
                              case "pitch":
                                ach.push("pitch", "participant", "training", "finalist");
                                break;
                              case "agri":
                                ach.push("agri", "participant", "training", "finalist");
                                break;
                              case "health":
                                ach.push("health", "participant", "training", "finalist");
                                break;
                              case "design":
                                ach.push("design", "participant", "training", "finalist");
                                break;
                              case "all":
                                ach.push("pitch", "health", "agri", "design", "women", "bestvideo", "bestproposal", "advisor", "bestdemo", "iotsustain", "bestsocmed", "bestpcb", "bestproto", "winner 1", "winner 2", "winner 3", "participant", "training", "finalist");
                                break;
                              case "t":
                                ach.push("training");
                                break;
                            }
                          } else {
                            certData.forEach((cert) => {
                              console.log(cert);
                              if (achievements === cert.Category) {
                                ach.push(cert.Category);
                              }
                            });
                          }
  
                          let datamodal = [];
                          for (const res of certData) {
                            if (ach.includes(res.Category)) {
                              console.log(res);
                              datamodal.push({
                                cat: res.Category,
                                certid: val['custom:CertificateID'],
                                certname: certs.tenant !== "admin" ? res.filename : res.id,
                                x: res.x,
                                y: res.y,
                                tenant: certs.tenant,
                                eventname: certs.tenant !== "admin" ? res.eventId : certs.id,
                                fontsize: res.fontsize,
                                serialX: res.serialX,
                                serialY: res.serialY,
                                eventcode: certs.code || 0,
                                ssm: certs.ssm || 0,
                                program: certs.tenant !== "admin" ? val["custom:program"] : "null"
                              });
                            }
                          }
                          settitle(certs.tenant !== "admin" ? certs.name : certs.id);
                          setdata1(datamodal);
                          setmodal(true);
                        });
                      } catch (error) {
                        console.error(error);
                      }
                    }}><Icon>visibility</Icon></SuiButton>,
                    event: certs.tenant !== "admin" ? certs.name : certs.id,
                    Date: [certs.date],
                    Location: [certs.location],
                  }]);
                }
              },
              download: true,
              header: true,
              error: (error) => {
                console.log(error);
              }
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  useEffect(()=>{
    setmodal(false)
    settitle(eventName)
    const columns = [
      { name: "download", align: "center" },
      { name: "event", align: "Left" },
      { name: "Date", align: "Left" },
      { name: "Location", align: "Left" },
    
    ];
    setdatamodal(<Table columns={columns} rows={rows} />)
  },[rows])
 
  useEffect(()=>{
    const rowe = []
    data1.map((row)=>{
      
      let cat = ""
      if(row.cat == 'winner 1' || row.cat == 'Winner'){
        cat = "Winner"
      }
      else if(row.cat == 'winner 2'){
        cat = "First Runner Up"
      }
      else if(row.cat == 'winner 3'){
        cat = "Second Runner Up"
      }
      else if(row.cat == 'training' || row.cat == "t"){
        cat = "Training"
      }
      else if(row.cat == 'participant'){
        cat = "Participant"
      }
      else if(row.cat == 'finalist'){
        cat = "Finalist"
      }
      else if(row.cat == 'advisor'){
        cat = "Appreciation"
      }
      else if(row.cat == 'bestdemo'){
        cat = "Best Demo"
      }
      else if(row.cat == 'bestproto'){
        cat = "Best IoT Prototype"
      }
      else if(row.cat == 'bestsocmed'){
        cat = "Social Media Involvement Award"
      }
      else if(row.cat == 'bestpcb'){
        cat = "Best PCB Design"
      }
      else if(row.cat == 'iotsustain'){
        cat = "IoT Sustainability Award"
      }
      else if(row.cat == 'women'){
        cat = "Women Empowerment"
      }
      else if(row.cat == 'bestproposal'){
        cat = "Best Project Proposal"
      }
      else if(row.cat == 'bestvideo'){
        cat = "Best Video"
      }
      else if(row.cat == 'coding'){
        cat = "Coding Maestro"
      }
      else if(row.cat == 'pitch'){
        cat = "Best Pitch"
      }
      else if(row.cat == 'agri'){
        cat = "Smart Agriculture Innovator"
      }
      else if(row.cat == 'health'){
        cat = "Healthcare Innovator"
      }
      else if(row.cat == 'design'){
        cat = "Design Excellence"
      }
      rowe.push({
        
        Achievements: cat != "" ? cat : row.cat,
        Certificate: <SuiButton variant="text" color="primary" size="large" onClick={()=>{modifyPdf(row.certname, row.x,row.y,row.fontsize,row.certid,row.tenant,row.eventname,row.serialX,row.serialY,row.eventcode,row.ssm, cat, row.program)}}><Icon>file_download</Icon></SuiButton>
      })
    })
    setrowes(rowe)
  },[data1])
 
useEffect(()=>{
  const columns1 = [
    { name: "Achievements", align: "center" },
    { name: "Certificate", align: "center" },
 
  ];
 
  setdatamodal(<Table columns={columns1} rows={rowes}/>)
 
},[rowes])
 
 
  async function modifyPdf(file,x,y,size,certid,tenant,eventname,serialX,serialY,eventcode,ssm,cat,program) {
    console.log(eventcode)
    console.log(ssm)
    console.log(cat)
    console.log(program)  
  
    const categoryCodes = {
      winner: "A",
      "winner 1": "A",
      "runner-up": "B",
      "winner 2": "B",
      "second runner-up": "D",
      "winner 3": "D",
      participant: "E",
      finalist: "F",
      training: "G",
      advisor: "H"
    };
  
    let unlistedCategoryCounter = 1;
    const unlistedCategoryCodes = {};
  
    const getCategoryCode = (category) => {
      const normalizedCategory = category.toLowerCase().replace(/\s+/g, '-');
      if (categoryCodes[normalizedCategory]) {
        return categoryCodes[normalizedCategory];
      } else if (unlistedCategoryCodes[normalizedCategory]) {
        return unlistedCategoryCodes[normalizedCategory];
      } else {
        const newCode = `C${unlistedCategoryCounter}`;
        unlistedCategoryCodes[normalizedCategory] = newCode;
        unlistedCategoryCounter++;
        return newCode;
      }
    };
    
    const shortUsername = username.slice(-4);
    const formattedSsm = ssm ? ssm.replace('-', '') : "00001";
    
    setload(true)
    let existingPdfBytes = null;
    if(tenant != "admin") {
       existingPdfBytes = await fetch(`https://certificatesys.s3.ap-southeast-1.amazonaws.com/${tenant}/${eventname}/${file}`).then(res => res.arrayBuffer())
 
    }
    else {
      existingPdfBytes = await fetch(`https://certificatesys.s3.ap-southeast-1.amazonaws.com/${file}`).then(res => res.arrayBuffer())
 
    }
    const pdfDoc = await PDFDocument.load(existingPdfBytes)
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
    const pages = pdfDoc.getPages()
    const firstPage = pages[0]
    const { width, height } = firstPage.getSize()
 
      // Load the PNG image (local or from a URL)
    const pngResponse = await fetch(localPngImage); // Use the imported PNG file
    const pngImageBytes = await pngResponse.arrayBuffer();
    const pngImage = await pdfDoc.embedPng(pngImageBytes);
 
    const pngDims = pngImage.scale(0.4); // Scale the image (adjust as needed)
    
 
    if(tenant == "admin") {
    firstPage.drawText(name, {
      x: width / 2 + parseInt(x),
      y: height / 2 + parseInt(y),
      size: parseInt(size),
      font: helveticaFont,
    })
 
    if(title == "iaM Digital Xperience 2022") {
      firstPage.drawText("sn: iaM-DXP" + certid, {
        x: width / 2 + parseInt("-390"),
        y: height / 2 + parseInt("-265"),
        size: parseInt("8"),
        font: helveticaFont,
      })
    }
    else {
    firstPage.drawText("sn: " + certid, {
      x: width / 2 + parseInt("380"),
      y: height / 2 + parseInt("290"),
      size: parseInt("8"),
      font: helveticaFont,
    })
  }
}
 
else {
       // Calculate the width of the text
       const textWidth = helveticaFont.widthOfTextAtSize(name, parseInt(size));
       // Calculate the x-coordinate to center the text
       const centerX = (textWidth) * 1/4;
 
 
        if(textWidth < 122){
          firstPage.drawText(name, {
            x: parseInt(x)+40,
            y: height - parseInt(y)-35,
            size: parseInt(size),
            font: helveticaFont,
           //  color: rgb(parseFloat(R), parseFloat(G), parseFloat(B)),
          });
        }else{
          firstPage.drawText(name, {
            x: parseInt(x) - centerX,
            y: height - parseInt(y)-35,
            size: parseInt(size),
            font: helveticaFont,
           //  color: rgb(parseFloat(R), parseFloat(G), parseFloat(B)),
          });
        }
         
         firstPage.drawText(`${formattedSsm}-${eventcode}-${getCategoryCode(cat)}-${shortUsername}`, {
          x: parseInt(serialX),
          y: height - parseInt(serialY) - 12,
          size: parseInt(12),
          font: helveticaFont,
          //  color: rgb(parseFloat(R), parseFloat(G), parseFloat(B)),
        });
 
        if(tenant=="Admin Cert"){
        const programtextWidth = helveticaFont.widthOfTextAtSize(program, parseInt(14));
       const programcenterX = (programtextWidth) * 1/4;

          if(program == "KEJOHANAN ESPORTS MOBILE LEGEND SEPANG") {
            firstPage.drawText(program, {
              x: parseInt(x) - programcenterX - 15,
              y: height - parseInt(y)-120,
              size: 14,
              font: helveticaFont,
            })
          }
          else if(program == "PUSHBIKE FUNRACE") {
            firstPage.drawText(program, {
              x: parseInt(x) - programcenterX,
              y: height - parseInt(y)-120,
              size: 18,
              font: helveticaFont,
            })
          }
          else if(program == "FUTSAL PIALA PEBS SEPANG") {
            firstPage.drawText(program, {
              x: parseInt(x) - programcenterX,
              y: height - parseInt(y)-120,
              size: 16,
              font: helveticaFont,
            })
          }
          else if(program == "SEPANG DARTX BELIA") {
            firstPage.drawText(program, {
              x: parseInt(x) - programcenterX + 20,
              y: height - parseInt(y)-120,
              size: 16,
              font: helveticaFont,
            })
          }
          else if(program == "NETBALL SHOOT-OUT TOURNAMENT") {
            firstPage.drawText(program, {
              x: parseInt(x) - programcenterX,
              y: height - parseInt(y)-120,
              size: 14,
              font: helveticaFont,
            })
          }
          else {
            firstPage.drawText(program, {
              x: parseInt(x) - programcenterX,
              y: height - parseInt(y)-120,
              size: 14,
              font: helveticaFont,
            })
          }

          
 
            // firstPage.drawText("("+username+")", {
            //   x: 230,
            //   y: height - parseInt(y)-70,
            //   size: 18,
            //   font: helveticaFont,
            // })
   
        }
 
 
 
        firstPage.drawImage(pngImage, {
          x: width/2.25, // X-coordinate (adjust as needed)
          y: height-(height- 15), // Y-coordinate (adjust as needed)
          width: pngDims.width,
          height: pngDims.height,
      });  
 
}
    // Serialize the PDFDocument to bytes (a Uint8Array)
    const pdfBytes = await pdfDoc.save()
    const bytes = new Uint8Array(pdfBytes);
    const blob = new Blob([bytes], { type: "application/pdf" });
    const docUrl = URL.createObjectURL(blob);
    window.open(docUrl,"_blank")
    setload(false)
}
 
  useEffect(()=>{
    if(load==true){
      settitle("")
      setdatamodal(
      <>
      <div className="loading-cert">
      <div>Generating Certificate</div>
      <div className="boxes">
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
      <div className="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
  </div>
      </div>
     
      </>)
    }
    else if(load==false){
      row();
    }
  },[load])
 
 
 
if(username!="" && username!="admin") {
  return (
    <>
    
    <Card>
 
      <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
        <SuiTypography variant="h6" gutterBottom>
          {title}
        </SuiTypography>
        <div hidden={!modal}>
          <SuiButton variant="outlined" color="info" size="small" style={{ float: "right" }} onClick={() => { row(); } }>back</SuiButton>
        </div>
      </SuiBox>
      <SuiBox
        sx={{
          "& .MuiTableRow-root:not(:last-child)": {
            "& td": {
              borderBottom: ({ borders: { borderWidth, borderColor } }) => `${borderWidth[1]} solid ${borderColor}`
            }
          }
        }}
      >
 
        {datamodal}
        {/* <Modal isOpen={modal} style={customStyles}>
<SuiButton variant="gradient" color="dark" onClick={()=>{setmodal(false)}} style={{float:"right"}}><Icon sx={{ fontWeight: "bold" }}>remove</Icon>
</SuiButton>
<br/>
<br/>
<Table columns={columns1} rows={rowes}/>
</Modal> */}
 
      </SuiBox>
    </Card>
 
    </>
  );
}
 
else {
  return (<></>)
}
}
export default Projects;